define('plugin/invoice/collection/InvoicePackageInstanceCollection',['require','lib/collection/BaseCollection','plugin/invoice/model/InvoicePackageInstanceModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var InvoicePackageInstanceModel = require('plugin/invoice/model/InvoicePackageInstanceModel');

    /**
     * Invoice package instance collection
     *
     * @class InvoicePackageInstanceCollection
     */
    return BaseCollection.extend({

        model: InvoicePackageInstanceModel

    });

});
